import React, { PureComponent } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import {
  getPolicy,
  saveAnonymousToken,
  submitPolicyNumber,
} from '../../store/actions';
import ModalPortal from '../../components/ModalPortal';
import qs from 'qs';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import * as analytics from '../../services/analytics';
import logo from './chubb-logo-dark.svg';
import './SubmitPolicyView.css';

const propTypes = {
  getPolicy: PropTypes.func,
  saveAnonymousToken: PropTypes.func,
};

class SubmitPolicyView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFetchingPolicy: true,
      hasTokenError: false,
      policyNumber: '',
      confirmPolicyNumber: '',
      clientLastName: '',
      reconfirmPolicyNumber: '',
    };
  }

  componentDidMount() {
    analytics.page('Broker Portal - Submit Policy');
    analytics.track('Broker Portal - Carrier Auth Started');
    this.props.saveAnonymousToken(this.props.query.token);
    this.props
      .getPolicy(this.props.query.policy_id)
      .then((policy) => {
        analytics.track('Broker Portal - Carrier Auth Get Policy Succeeded');
        this.setState({
          isFetchingPolicy: false,
        });
      })
      .catch((error) => {
        analytics.track('Broker Portal - Carrier Auth Get Policy Failed');
        this.setState({
          isFetchingPolicy: false,
          hasTokenError: true,
        });
      });
  }

  componentWillUnmount() {
    window.$(this.modal).modal('hide');
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.isSubmitDisabled) {
      analytics.track('Broker Portal - Submit Policy Info Submitted');
      window.$(this.modal).modal('show');
    }
  };

  handleConfirm = (e) => {
    e.preventDefault();
    if (!this.isConfirmDisabled) {
      analytics.track('Broker Portal - Submit Policy Info Confirmed');
      this.props
        .submitPolicyNumber({
          policyId: this.props.policy.id,
          policyNumber: this.state.policyNumber,
        })
        .then(() => {
          analytics.track('Broker Portal - Submit Policy Info Succeeded');
          window.$(this.modal).modal('hide');
          window
            .$('.SubmitPolicyView')
            .pgNotification({
              message: `Policy #${this.state.policyNumber} has been submitted.`,
              type: 'success',
              position: 'top-left',
            })
            .show();
        })
        .catch((error) => {
          analytics.track('Broker Portal - Submit Policy Info Failed');
          window
            .$('.SubmitPolicyView')
            .pgNotification({
              message: error.message || 'Something went wrong',
              type: 'danger',
              position: 'top-left',
            })
            .show();
        });
    }
  };

  preventEvent = (e) => {
    e.preventDefault();
    return false;
  };

  get isSubmitDisabled() {
    return (
      !this.state.policyNumber ||
      !this.state.confirmPolicyNumber ||
      this.state.policyNumber !== this.state.confirmPolicyNumber
    );
  }

  get isConfirmDisabled() {
    const { clientLastName, policyNumber, reconfirmPolicyNumber } = this.state;
    const policy = this.props.policy;
    return (
      !clientLastName ||
      !reconfirmPolicyNumber ||
      clientLastName !== policy.client.person.last_name ||
      reconfirmPolicyNumber !== policyNumber
    );
  }

  render() {
    const { policy } = this.props;
    if (this.state.hasTokenError) {
      return <Redirect to="/login" />;
    } else if (this.state.isFetchingPolicy) {
      return <div />;
    } else {
      return (
        <div className="SubmitPolicyView">
          <div className="header">
            <div className="brand inline">
              <img src={logo} alt="Chubb logo" width="190" height="20" />
            </div>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6">
                <h1 className="SubmitPolicyView-heading">
                  {policy.policy_number
                    ? 'Policy information'
                    : 'Submit policy information'}
                </h1>
                <div className="card">
                  <table className="table no-margin">
                    <thead>
                      <tr style={{ backgroundColor: '#f0f0f0' }}>
                        <th colSpan="2" style={{ color: '#2c2c2c' }}>
                          Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Client name</td>
                        <td>
                          {policy.client.person.first_name}{' '}
                          {policy.client.person.last_name}
                        </td>
                      </tr>
                      <tr>
                        <td>Plan type</td>
                        <td>
                          {capitalize(
                            get(policy, 'plan.settings.details.plan_type')
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Plan name</td>
                        <td>
                          {capitalize(get(policy, 'plan.settings.plan_title'))}
                        </td>
                      </tr>
                      {get(
                        policy,
                        'plan.settings.details.optional_coverages.golf_package'
                      ) && (
                        <tr>
                          <td>Add on</td>
                          <td>
                            {capitalize(
                              get(
                                policy,
                                'plan.settings.details.optional_coverages.golf_package.title'
                              )
                            )}
                          </td>
                        </tr>
                      )}
                      {get(
                        policy,
                        'plan.settings.details.optional_coverages.trip_cancellation'
                      ) && (
                        <tr>
                          <td>Add on</td>
                          <td>
                            {capitalize(
                              get(
                                policy,
                                'plan.settings.details.optional_coverages.trip_cancellation.title'
                              )
                            )}
                          </td>
                        </tr>
                      )}
                      {policy.policy_number && (
                        <tr>
                          <td>Policy number</td>
                          <td>{policy.policy_number}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {!policy.policy_number && (
                  <div className="card">
                    <div className="card-block">
                      <p>
                        Please confirm policy information is correct to complete
                        the issuance process.
                      </p>
                      <form onSubmit={this.handleSubmit}>
                        <div className="form-group row">
                          <label className="col-md-3 text-uppercase">
                            Policy info
                          </label>
                          <div className="col-md-9">
                            <div className="form-group">
                              <label
                                htmlFor="policyNumber"
                                className="text-uppercase"
                              >
                                Policy number
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                id="policyNumber"
                                name="policyNumber"
                                value={this.state.policyNumber}
                                required
                                aria-required="true"
                                onChange={this.handleChange}
                                onPaste={this.preventEvent}
                              />
                            </div>
                            <div className="form-group">
                              <label
                                htmlFor="confirmPolicyNumber"
                                className="text-uppercase"
                              >
                                Confirm policy number
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                id="confirmPolicyNumber"
                                name="confirmPolicyNumber"
                                value={this.state.confirmPolicyNumber}
                                required
                                aria-required="true"
                                onChange={this.handleChange}
                                onPaste={this.preventEvent}
                              />
                            </div>
                            <button
                              type="submit"
                              className="btn btn-large btn-complete"
                              disabled={this.isSubmitDisabled}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <ModalPortal>
            <div
              className="modal"
              id="confirmPolicyModal"
              ref={(c) => (this.modal = c)}
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content-wrapper">
                  <form className="form" onSubmit={this.handleConfirm}>
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirm policy</h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <p>
                          Please confirm policy information is correct to
                          complete the issuance process.
                        </p>
                        <div className="form-group row">
                          <label className="col-md-3 text-uppercase">
                            Policy details
                          </label>
                          <div className="col-md-9">
                            <div className="form-group">
                              <label
                                htmlFor="clientLastName"
                                className="text-uppercase"
                              >
                                Confirm client last name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="clientLastName"
                                name="clientLastName"
                                value={this.state.clientLastName}
                                required
                                aria-required="true"
                                onChange={this.handleChange}
                              />
                            </div>
                            <div className="form-group">
                              <label
                                htmlFor="reconfirmPolicyNumber"
                                className="text-uppercase"
                              >
                                Confirm policy number
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="reconfirmPolicyNumber"
                                name="reconfirmPolicyNumber"
                                value={this.state.reconfirmPolicyNumber}
                                required
                                aria-required="true"
                                onChange={this.handleChange}
                                onPaste={this.preventEvent}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-large btn-complete"
                          disabled={this.isConfirmDisabled}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </ModalPortal>
        </div>
      );
    }
  }
}

SubmitPolicyView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => {
  const query = qs.parse(ownProps.location.search, {
    ignoreQueryPrefix: true,
  });
  return {
    policy: state.policies[query.policy_id],
    query,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPolicy,
      saveAnonymousToken,
      submitPolicyNumber,
    },
    dispatch
  );

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(SubmitPolicyView);
